






















































import { Messages } from "@/constants/messages";
import Vue from "vue";
import { App } from "@/model/App";
import img from "../assets/images_placeholder.jpg";
import { ROUTES } from "@/constants/routes";

export default Vue.extend({
  name: "AppCard",
  data(): {
    mess: any;
    imageLoaded: boolean;
    iconLoaded: boolean;
    imgPlaceholder: any;
  } {
    return {
      mess: Messages,
      imageLoaded: false,
      iconLoaded: false,
      imgPlaceholder: img,
    };
  },
  computed: {
    getAltImage(): string {
      return this.app.appName + this.mess.ownership_banner;
    },
    getIconImage(): string {
      return this.app.appName + this.mess.ownership_icon;
    },
  },
  methods: {
    loadedImage(): void {
      this.imageLoaded = true;
    },
    loadedIcon(): void {
      this.iconLoaded = true;
    },
    dealWithError(event: any): void {
      event.target.src = this.imgPlaceholder;
    },
    goToDetails(): void {
      this.$router.push({
        name: ROUTES.DETAILS_APP.name,
        params: { name: this.app.appName },
      });
    },
  },
  props: {
    app: {
      type: Object as () => App,
    },
  },
});
